import React, { useState } from "react";
import useLocalStorage from "../../Hooks/useLocalStorage";
import axios from "axios";

export default function QuestionnaireDebut() {
	const [handicap, setHandicap] = useState();

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");
	const formation = urlParams.get("formation");

	const [fonction, setFonction] = useState("");
	const [attentes, setAttentes] = useState("");
	const [connaissances, setConnaissances] = useState("");
	const [remarques, setRemarques] = useState("");
	const [sent, setSent] = useLocalStorage("completedDebut", false);
	const [error, setError] = useState("");

	const sendForm = async e => {
		e.preventDefault();

		var resHandicap;

		if (handicap === 1) {
			resHandicap = "Non";
		}

		if (handicap === 0) {
			resHandicap = "Oui";
		}

		try {
			axios.post("https://global-academie.herokuapp.com/avis/debut", {
				userID,
				userName,
				formation,
				resHandicap,
				fonction,
				attentes,
				connaissances,
				remarques,
			});
			setSent(true);
		} catch (error) {
			console.log(error);
		}
	};

	if (error) {
		setTimeout(() => {
			setError("");
		}, 3000);
	}

	return (
		<div className="flex min-h-screen w-full flex-col items-center justify-center">
			<form
				onSubmit={sendForm}
				className="my-16 flex w-full flex-col items-center justify-center space-y-7 md:w-[60%]"
			>
				<h2 className=" flex w-full items-center justify-between text-3xl font-bold text-indigo-500">
					Questionnaire besoin (action de formation)
				</h2>
				<hr className="my-4 h-[3px] w-[100px] self-start border-none bg-indigo-200" />
				<div
					className={
						sent
							? "flex h-[0px] flex-col items-center justify-center opacity-0 transition-all duration-300 ease-in-out"
							: "flex flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
					}
				>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="fonction"
						>
							Fonction exercée ? Depuis combien de temps ?
						</label>
						<textarea
							value={fonction}
							onChange={e => setFonction(e.target.value)}
							name="fonction"
							id="fonction"
							placeholder="Fonction exercée"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="attentes"
						>
							Quelles sont vos attentes / besoins concernant cette
							formation?
						</label>
						<textarea
							value={attentes}
							onChange={e => setAttentes(e.target.value)}
							name="attentes"
							id="attentes"
							placeholder="Attentes"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="connaissances"
						>
							Quelles sont vos connaissances au démarrage de la
							formation?
						</label>
						<textarea
							value={connaissances}
							onChange={e => setConnaissances(e.target.value)}
							name="connaissances"
							id="connaissances"
							placeholder="Connaissances au démarrage de la formation"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="remarques"
						>
							Autres remarques ?
						</label>
						<textarea
							value={remarques}
							onChange={e => setRemarques(e.target.value)}
							name="remarques"
							id="remarques"
							placeholder="Remarques"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>

					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="contrat"
						>
							Avez-vous un handicap nécessitant un aménagement
							spécifique du bilan de compétences?
						</label>
						<div className="mt-3 flex w-full items-center justify-start space-x-6">
							<button
								type="button"
								onClick={() => setHandicap(0)}
								className={
									handicap === 0
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Oui
							</button>
							<button
								type="button"
								onClick={() => setHandicap(1)}
								className={
									handicap === 1
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Non
							</button>
						</div>
					</div>
					{error && (
						<span className="w-full rounded bg-red-100 p-3 font-medium text-red-500">
							{error}
						</span>
					)}
					<button
						type="submit"
						className="w-full rounded-md border-2 border-transparent bg-indigo-500 p-3 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
					>
						Envoyer
					</button>
				</div>
				<div
					className={
						sent
							? "visible-check flex h-[250px] flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
							: "flex h-[0px] flex-col items-center justify-center overflow-hidden opacity-0 transition-all duration-300 ease-in-out"
					}
				>
					<svg
						className="checkmark"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 52 52"
					>
						<circle
							className="checkmark__circle"
							cx="26"
							cy="26"
							r="25"
							fill="none"
						/>
						<path
							className="checkmark__check"
							fill="none"
							d="M14.1 27.2l7.1 7.2 16.7-16.8"
						/>
					</svg>
					<h4 className="my-7 text-2xl font-medium">
						Merci pour vos réponses!
					</h4>
				</div>
			</form>
		</div>
	);
}
